import { render, staticRenderFns } from "./authenticating.component.vue?vue&type=template&id=dd1821d0&scoped=true"
import script from "./authenticating.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./authenticating.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./authenticating.component.vue?vue&type=style&index=0&id=dd1821d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1821d0",
  null
  
)

export default component.exports